export class StringUtils {
  public static toKebabCase (otherCase: string) {
    return otherCase.replace(/([a-z])([A-Z])/g, '$1-$2')
      .replace(/\s+/g, '-')
      .toLowerCase()
  }

  public static toSnakeCase (otherCase: string) {
    return otherCase.replace(/([a-z])([A-Z])/g, '$1_$2')
      .replace(/\s+/g, '_')
      .toLowerCase()
  }

  /**
   * http://stackoverflow.com/a/10997390/11236
   */
  public static updateURLParameter (url: string, param: string, paramVal: string) {
    let newAdditionalURL = ''
    let tempArray = url.split('?')
    const baseURL = tempArray[0]
    const additionalURL = tempArray[1]
    let temp = ''
    if (additionalURL) {
      tempArray = additionalURL.split('&')
      for (let i = 0; i < tempArray.length; i++) {
        if (tempArray[i].split('=')[0] !== param) {
          newAdditionalURL += temp + tempArray[i]
          temp = '&'
        }
      }
    }

    const rowsTxt = temp + '' + param + '=' + paramVal
    return baseURL + '?' + newAdditionalURL + rowsTxt
  }

  /**
   *  https://stackoverflow.com/a/8809472
   */
  public static generateUUID () { // Public Domain/MIT
    let d = new Date().getTime()// Timestamp
    let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0// Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = Math.random() * 16// random number between 0 and 16
      if (d > 0) { // Use timestamp until depleted
        r = (d + r) % 16 | 0
        d = Math.floor(d / 16)
      } else { // Use microseconds since page-load if supported
        r = (d2 + r) % 16 | 0
        d2 = Math.floor(d2 / 16)
      }
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
  }

  /**
   * https://stackoverflow.com/a/49634926
   */
  public static linkify (inputText: string): string {
    let replacedText = ''

    // URLs starting with http://, https://, or ftp://
    const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim // eslint-disable-line no-useless-escape
    replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>')

    // URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    const replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim // eslint-disable-line no-useless-escape
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>')

    // Change email addresses to mailto:: links.
    const replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim // eslint-disable-line no-useless-escape
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>')

    return replacedText
  }

  public static toMoneyString (amount: number) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(amount)
  }
}
